import { render, staticRenderFns } from "./VolumeReports.vue?vue&type=template&id=67c98086&scoped=true"
import script from "./VolumeReports.vue?vue&type=script&lang=js"
export * from "./VolumeReports.vue?vue&type=script&lang=js"
import style0 from "./VolumeReports.vue?vue&type=style&index=0&id=67c98086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c98086",
  null
  
)

export default component.exports